module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/logit-one-chooses-linescape-as-sailling-schedule-provider/logit-one-chooses-linescape-as-sailling-schedule-provider.scss
// module id = 885
// module chunks = 0